<template>
  <div class="data-table-actions">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "DataTableActions"
};
</script>
<style>
.data-table-actions {
  display: flex;
  justify-content: end;
  text-wrap: nowrap;
}

.data-table-actions button {
  border: 1px solid rgb(118, 118, 118, 0.75);
  border-right: none;
  text-wrap: nowrap;
}
.data-table-actions button:focus,
.data-table-actions input:focus {
  outline: rgba(102, 179, 227, 0.75) auto 1px !important;
  outline-offset: 0px;
  z-index: 99;
}
.data-table-actions button:first-of-type {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.data-table-actions button:last-of-type {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-right: 1px solid rgb(118, 118, 118);
}

.form-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  margin: auto;
}
.form-row:last-child {
  flex-grow: 1;
}

.one-column-layout {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}

.drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
